// extracted by mini-css-extract-plugin
export default {"addressBlock":"DepositAddress_addressBlock__Ovpyo","address":"DepositAddress_address__QJVPD","copy":"DepositAddress_copy__+LwyZ"};